import React, { useState } from "react";

import leadSourceService from "../../components/Services/LeadSourceService";

const useLeadSource = () => {
  const [sourceData, setSourceData] = useState([]);

  const fetchLeadSource = async () => {
    try {
      const response = await leadSourceService.fetchLeadSources();
      const data = response.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setSourceData(data);
    } catch (error) {
      console.log(error);
    }
  };
  
  return {
    sourceData,
    setSourceData,
    fetchLeadSource,
  };
};

export default useLeadSource;
